<template>
  <div class="common-poup  bind-notice-box">
    <h1 class="poup-title">石头网 · 操作提示</h1>
    <div class="form-wrapper-new">
			<div class="notice-box">恭喜您，操作成功！</div>
			<!-- <div class="timeout-box">{{seconds}}秒后自动跳转</div>
			<button class="login-btn" @click="linkToIndex">进入首页</button> -->
    </div>    
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  props: {},
   data(){
    	return{
				 seconds:5,
				 timer:null
        };
    },
    components:{},
    created:function(){},
    mounted:function(){
			  var _this = this;
		  // 	_this.timer=setInterval(function(){
			// 	 _this.seconds--;
			// 	 if (!_this.seconds) {
			// 		 clearInterval(_this.timer);
			// 		 _this.$emit('closepoup');
			// 	 }
			// },1000);
    },
    methods:{
    	linkToIndex(){
				this.$emit('closepoup');
			}
    }
};
</script>
<style lang="scss"  scoped="scoped">
@import "~scss/mixin";
@import "~scss/poup";
* {
		margin: 0;
		padding: 0;
		-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
		-ms-tap-highlight-color: rgba(0, 0, 0, 0);
		tap-highlight-color: rgba(0, 0, 0, 0);
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		-ms-box-sizing: border-box;
		box-sizing: border-box;
		-ms-text-size-adjust: 100%;
		-webkit-text-size-adjust: 100%;
}
div.bind-notice-box{
    width:446px;
	height:400px;
	// z-index: 100;
    h1.poup-title{
        background:url(~images/notice_title.png) no-repeat 10px 10px;
        text-indent:-9999px;
        margin-bottom:42px;
        height: 40px;
		}
		div.form-wrapper-new{
			div.notice-box{
				font-size: 20px;
				padding-top: 170px;
				background: url(~images/notice_success.png) no-repeat center top;
				margin-bottom: 20px;
				text-align: center;
			}
			div.timeout-box{
				color: $color-info;
				margin-bottom: 20px;
				text-align: center;
			}
		}
		
}

</style>


// WEBPACK FOOTER //
// src/components/noticePoup.vue